import React from "react";
import { NavLink } from "react-router-dom";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

// TRUN consultar con monca sobre llamadas a los importadores que estan relacionasdos con un RUN

const MenuImporters = ({ oetID, runID, status, run, oet}) => {
    return (
        <UncontrolledDropdown>
            {(status === 1 || status === 4 || status === 5) && [
                <DropdownToggle caret key="ipm_1">
                    Options
                </DropdownToggle>,
                <DropdownMenu right key="ipm_2">
                    {/*{status === -1 && (*/}
                    {/*    <DropdownItem*/}
                    {/*        tag={NavLink}*/}
                    {/*        exact={true}*/}
                    {/*        activeClassName="active"*/}
                    {/*        to={`/site/importer/${oetID}/${runID}/`}*/}
                    {/*    >*/}
                    {/*        <span>Sites Importer</span>*/}
                    {/*    </DropdownItem>*/}
                    {/*)}*/}
                    {/*{status === 1 && <DropdownItem divider />}*/}
                    {status === 1 && run.action !== "amend" && (
                        <DropdownItem
                            tag={NavLink}
                            activeClassName="active"
                            to={`/ssot-non-sode-importer/importer/${oetID}/${runID}/`}
                        >
                            <span>SSOT Importer </span>
                        </DropdownItem>
                    )}
                    {status === 1 && run.action === "amend" && (
                        <DropdownItem tag={NavLink} activeClassName="active" to={`/amend/importer/${oetID}/${runID}/`}>
                            <span>SSOT Importer </span>
                        </DropdownItem>
                    )}
                    {/*{status > 1 && <DropdownItem divider />}*/}
                    {status === 4 && oet.customer_purchase_order.budget_approval && (
                        <DropdownItem
                            tag={NavLink}
                            activeClassName="active"
                            to={`/non-sode-ssot-cpm-importer/${oetID}/${runID}/`}
                        >
                            <span>SSOT Importer CPM</span>
                        </DropdownItem>
                    )}
                    {status === 4 && !oet.customer_purchase_order.budget_approval && (
                        <DropdownItem
                            tag={NavLink}
                            activeClassName="active"
                            to={`/ssot-non-sode-cpm-importer/importer/${oetID}/${runID}/`}
                        >
                            <span>CPM SSOT IMPORTER  </span>
                        </DropdownItem>
                    )}
                    {status === 5 && (
                        <React.Fragment>
                            <DropdownItem
                                tag={NavLink}
                                activeClassName="active"
                                to={`/non-sode/ssot-omc-importer/${oetID}/${runID}/`}
                            >
                                <span>SSOT Importer OMC</span>
                            </DropdownItem>
                            {/*<DropdownItem*/}
                            {/*    tag={NavLink}*/}
                            {/*    activeClassName="active"*/}
                            {/*    to={`/siteomc/importer/omc/${oetID}/${runID}/`}*/}
                            {/*>*/}
                            {/*    <span>Site Importer OMC</span>*/}
                            {/*</DropdownItem>*/}
                            {/*<DropdownItem*/}
                            {/*    tag={NavLink}*/}
                            {/*    activeClassName="active"*/}
                            {/*    to={`/pr-importer/${oetID}/${runID}/`}*/}
                            {/*>*/}
                            {/*    <span>PR importer</span>*/}
                            {/*</DropdownItem>*/}
                            {/*<DropdownItem*/}
                            {/*    tag={NavLink}*/}
                            {/*    activeClassName="active"*/}
                            {/*    to={`/pr-omc-importer/${oetID}/${runID}/`}*/}
                            {/*>*/}
                            {/*    <span>(PR) OET OMC Importer</span>*/}
                            {/*</DropdownItem>*/}
                        </React.Fragment>
                    )}
                </DropdownMenu>
            ]}
        </UncontrolledDropdown>
    );
};

export default MenuImporters;
